<template>
    <div>
        <v-container class="toolbar__container">
            <v-form ref="form" v-model="formValidado">
                <v-row>
                    <v-col cols="12" sm="6" md="2">
                        <v-datetime-picker
                            :label="$t('datetime.startDate')"
                            v-model="dti"
                            :time-picker-props="timeProps"
                            :text-field-props="textFieldProps"
                            :date-picker-props="dtiProps"
                            time-format="HH:mm:ss"
                            date-format="dd/MM/yyyy"
                            :clear-text="$t('datetime.close')"
                        >
                            <template slot="dateIcon"><v-icon>mdi-calendar</v-icon></template>
                            <template slot="timeIcon"><v-icon>mdi-clock</v-icon></template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <v-datetime-picker
                            :label="$t('datetime.finalDate')"
                            v-model="dtf"
                            :time-picker-props="timeProps"
                            :text-field-props="textFieldProps"
                            :date-picker-props="dtfProps"
                            time-format="HH:mm:ss"
                            date-format="dd/MM/yyyy"
                            :clear-text="$t('datetime.close')"
                        >
                            <template slot="dateIcon"><v-icon>mdi-calendar</v-icon></template>
                            <template slot="timeIcon"><v-icon>mdi-clock</v-icon></template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <v-text-field
                            v-model="codRota"
                            :label="$t('routeChangeHistory.filters.routeCode')"
                            clearable
                            dense
                        />
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <v-text-field
                            v-model="nomeDestinoFiltro"
                            :label="$t('routeChangeHistory.filters.destination')"
                            clearable
                            dense
                        />
                    </v-col>
                    <v-col cols="12" sm="1" md="1" align="end">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    small
                                    fab
                                    color="primary darken-1"
                                    class="white--text"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="populaRelatorio"
                                    style="margin-bottom: 5px;"
                                >
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('operation.search') }}</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>

        <MerusDataTable
            :headers="tableHeaders"
            :items="itemsFiltered"
            :loading="loading"
            :default-multi-sort="defaultSort"
            :loading-text="$t('routeChangeHistory.loading')"
            cod-tabela="RELHISTORICOALTERACOESROTAS"
            @update:headers="headers = $event"
        >
            <template v-slot:toolbar>
                <CadastroToolbar
                    :title="$t('routeChangeHistory.title')"
                    :token="token"
                    :items="itemsFiltered"
                    csv-title="historicoalteracoesrotas"
                    :pdf-title="$t('routeChangeHistory.title')"
                    :pdf-headers="tableHeaders"
                    pdf-filename="historicoalteracoesrotas"
                    hide-search
                />
            </template>
            <template v-slot:item.km_original="{ item }">
                {{ formatKm(item.km_original) }}
            </template>
            <template v-slot:item.km_atual="{ item }">
                {{ formatKm(item.km_atual) }}
            </template>
            <template v-slot:item.delta_km="{ item }">
                <span :class="deltaClass(item.delta_km)">{{ formatKmDelta(item.delta_km) }}</span>
            </template>
            <template v-slot:item.custo_original="{ item }">
                {{ formatMoney(item.custo_original) }}
            </template>
            <template v-slot:item.custo_atual="{ item }">
                {{ formatMoney(item.custo_atual) }}
            </template>
            <template v-slot:item.delta_custo="{ item }">
                <span :class="deltaClass(item.delta_custo)">{{ formatMoneyDelta(item.delta_custo) }}</span>
            </template>
            <template v-slot:item.pct_custo="{ item }">
                <span :class="deltaClass(item.pct_custo)">{{ formatPct(item.pct_custo) }}</span>
            </template>
            <template v-slot:item.modo_roteirizacao_extenso="{ item }">
                {{ modoRoteirizacaoLabel(item.id_modo_roteirizacao, item.modo_roteirizacao_extenso) }}
            </template>
            <template v-slot:item.constancia_custo_extenso="{ item }">
                {{ constanciaCustoLabel(item.constancia_custo, item.constancia_custo_extenso) }}
            </template>
            <template v-slot:item.ultima_origem="{ item }">
                {{ origemLabel(item.ultima_origem) }}
            </template>
            <template v-slot:item.actions="{ item }">
                <v-btn icon small color="primary" @click="openDetail(item)">
                    <v-icon small>mdi-compare</v-icon>
                </v-btn>
            </template>
        </MerusDataTable>

        <v-dialog v-model="detailShow" max-width="1200" scrollable>
            <v-card v-if="detailShow">
                <v-card-title>
                    {{ detailTitle }}
                    <v-spacer />
                    <v-btn icon @click="closeDetail"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-text>
                    <v-progress-linear v-if="detailLoading" indeterminate class="mb-4" />
                    <v-row v-else>
                        <v-col cols="12" md="8">
                            <v-row class="mb-2" dense>
                                <v-col cols="12" sm="6">
                                    <v-card outlined class="pa-3">
                                        <div class="text-subtitle-1 font-weight-bold mb-1">
                                            {{ selecionadaTitulo }}
                                        </div>
                                        <div v-for="info in resumoSelecionada" :key="info.label" class="body-2">
                                            {{ info.label }}: <strong>{{ info.valor }}</strong>
                                            <span v-if="info.delta" :class="deltaClass(info.deltaNum)">({{ info.delta }})</span>
                                        </div>
                                    </v-card>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-card outlined class="pa-3">
                                        <div class="text-subtitle-1 font-weight-bold mb-1">
                                            {{ baselineTitulo }}
                                        </div>
                                        <div v-if="!originalRow" class="body-2 text--secondary">—</div>
                                        <template v-else>
                                            <div v-for="info in resumoBaseline" :key="info.label" class="body-2">
                                                {{ info.label }}: <strong>{{ info.valor }}</strong>
                                            </div>
                                        </template>
                                    </v-card>
                                </v-col>
                            </v-row>

                            <v-row dense align="center" class="mb-1">
                                <v-col cols="auto">
                                    <v-checkbox
                                        v-model="showSelectedLayer"
                                        :disabled="!selectedGeojson"
                                        hide-details
                                        dense
                                        class="mt-0"
                                    >
                                        <template #label>
                                            <span class="har-swatch" :style="{ background: selectedColor }" />
                                            {{ $t('routeChangeHistory.mapSelected') }}
                                        </template>
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="auto">
                                    <v-checkbox
                                        v-model="showOriginalLayer"
                                        :disabled="!originalGeojson || selectedIsOriginal"
                                        hide-details
                                        dense
                                        class="mt-0"
                                    >
                                        <template #label>
                                            <span class="har-swatch har-swatch--dashed" :style="{ borderColor: originalColor }" />
                                            {{ $t('routeChangeHistory.mapOriginal') }}
                                        </template>
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="auto">
                                    <v-checkbox
                                        v-model="showOtimizadaLayer"
                                        :disabled="!otimizadaGeojson"
                                        hide-details
                                        dense
                                        class="mt-0"
                                    >
                                        <template #label>
                                            <span class="har-swatch" :style="{ background: optimizedColor }" />
                                            {{ $t('routeChangeHistory.mapOptimized') }}
                                            <template v-if="otimizada && otimizada.distancia != null">
                                                ({{ formatKm(otimizada.distancia / 1000) }})
                                            </template>
                                        </template>
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="auto">
                                    <v-checkbox
                                        v-model="showCercasLayer"
                                        :disabled="!rawCercas.length"
                                        hide-details
                                        dense
                                        class="mt-0"
                                    >
                                        <template #label>
                                            <span class="har-swatch har-swatch--fence" />
                                            {{ $t('routeChangeHistory.mapFences') }}
                                        </template>
                                    </v-checkbox>
                                </v-col>
                            </v-row>
                            <v-alert v-if="!hasAnyMapGeometry" type="info" dense outlined>
                                {{ $t('routeChangeHistory.mapEmpty') }}
                            </v-alert>
                            <div v-else class="har-map">
                                <l-map
                                    ref="detailMapRef"
                                    :key="mapKey"
                                    :zoom="zoom"
                                    :center="currentCenter"
                                    :options="mapOptions"
                                    style="height: 100%; width: 100%; border-radius: 8px;"
                                    @ready="onMapReady"
                                >
                                    <l-tile-layer :url="url" :attribution="attribution" />
                                    <l-geo-json
                                        v-if="mapOriginalGeojson"
                                        :geojson="mapOriginalGeojson"
                                        :options="originalUnderlayOptions"
                                    />
                                    <l-geo-json
                                        v-if="mapOriginalGeojson"
                                        :geojson="mapOriginalGeojson"
                                        :options="originalFlowOptions"
                                    />
                                    <l-geo-json
                                        v-if="mapOtimizadaGeojson"
                                        :geojson="mapOtimizadaGeojson"
                                        :options="optimizedUnderlayOptions"
                                    />
                                    <l-geo-json
                                        v-if="mapOtimizadaGeojson"
                                        :geojson="mapOtimizadaGeojson"
                                        :options="optimizedFlowOptions"
                                    />
                                    <l-marker
                                        v-for="(dir, di) in mapOtimizadaDirectionMarkers"
                                        :key="`dir-otm-${di}`"
                                        :lat-lng="latLng(dir.lat, dir.lng)"
                                        :icon="iconDirecaoRota(dir.bearing, optimizedColor)"
                                        :z-index-offset="5"
                                    />
                                    <l-geo-json
                                        v-if="mapSelectedGeojson"
                                        :geojson="mapSelectedGeojson"
                                        :options="selectedUnderlayOptions"
                                    />
                                    <l-geo-json
                                        v-if="mapSelectedGeojson"
                                        :geojson="mapSelectedGeojson"
                                        :options="selectedFlowOptions"
                                    />
                                    <l-marker
                                        v-for="(dir, di) in mapOriginalDirectionMarkers"
                                        :key="`dir-orig-${di}`"
                                        :lat-lng="latLng(dir.lat, dir.lng)"
                                        :icon="iconDirecaoRota(dir.bearing, originalColor)"
                                        :z-index-offset="6"
                                    />
                                    <l-marker
                                        v-for="(dir, di) in mapSelectedDirectionMarkers"
                                        :key="`dir-sel-${di}`"
                                        :lat-lng="latLng(dir.lat, dir.lng)"
                                        :icon="iconDirecaoRota(dir.bearing, selectedColor)"
                                        :z-index-offset="7"
                                    />
                                    <l-geo-json
                                        v-for="(cerca, w) in mapCercasGeojson"
                                        :key="`cerca-${cerca.id_cerca}-${w}`"
                                        :geojson="cerca.geojson"
                                        :options="cerca.options"
                                        :options-style="cerca.style"
                                        :visible="showCercasLayer"
                                    />
                                    <l-circle
                                        v-for="(cerca, w) in mapCercasCirculares"
                                        :key="`cerca-circ-${cerca.id_cerca}-${w}`"
                                        :lat-lng="latLng(cerca.lat_centro, cerca.lng_centro)"
                                        :radius="Number(cerca.raio_mts) || 0"
                                        :color="cerca._strokeColor"
                                        :fill-color="cerca._fillColor"
                                        :fill-opacity="0.25"
                                        :weight="2"
                                        :visible="showCercasLayer"
                                    />
                                    <l-marker
                                        v-for="(pin, p) in mapCercaMarkers"
                                        :key="`cerca-pin-${pin.id_cerca}-${p}`"
                                        :lat-lng="latLng(pin.lat, pin.lng)"
                                        :icon="iconPinCerca(pin.color)"
                                        :visible="showCercasLayer"
                                        :z-index-offset="10"
                                    >
                                        <l-tooltip
                                            v-if="pin.nome"
                                            :content="pin.nome"
                                            :options="{ direction: 'top', offset: [0, -28] }"
                                        />
                                        <l-popup v-if="pin.nome">
                                            <strong>{{ pin.nome }}</strong>
                                        </l-popup>
                                    </l-marker>
                                </l-map>
                            </div>
                        </v-col>
                        <v-col cols="12" md="4">
                            <div class="text-subtitle-2 mb-1">{{ $t('routeChangeHistory.timeline') }}</div>
                            <div class="text-caption mb-2 grey--text">
                                {{ $t('routeChangeHistory.mapSelectVersion') }}
                            </div>
                            <v-timeline dense clipped class="har-timeline">
                                <v-timeline-item
                                    v-for="row in detailRows"
                                    :key="row.id_historico_alteracao_rota"
                                    :color="timelineColor(row.tipo_evento)"
                                    small
                                >
                                    <div
                                        class="har-timeline-item"
                                        :class="{ 'har-timeline-item--active': isTimelineSelected(row) }"
                                        role="button"
                                        tabindex="0"
                                        @click="selectTimelineRow(row)"
                                        @keydown.enter.prevent="selectTimelineRow(row)"
                                        @keydown.space.prevent="selectTimelineRow(row)"
                                    >
                                        <div class="font-weight-medium">{{ formatDateTime(row.dt_evento) }}</div>
                                        <div class="text-caption">
                                            {{ tipoEventoLabel(row.tipo_evento) }}
                                            · {{ origemLabel(row.origem) }}
                                        </div>
                                        <div class="text-caption">
                                            {{ formatKm(row.km) }}
                                            · {{ formatMoney(row.custo_total) }}
                                            <template v-if="row.id_modo_roteirizacao != null">
                                                · {{ modoRoteirizacaoLabel(row.id_modo_roteirizacao) }}
                                            </template>
                                            <template v-if="row.cod_rota">
                                                · {{ row.cod_rota }}
                                            </template>
                                            <template v-if="row.id_linha != null">
                                                · {{ $t('routeChangeHistory.timelineLine') }} {{ row.id_linha }}
                                            </template>
                                        </div>
                                    </div>
                                </v-timeline-item>
                            </v-timeline>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import L from 'leaflet';
import {
    LMap,
    LTileLayer,
    LGeoJson,
    LCircle,
    LMarker,
    LTooltip,
    LPopup,
} from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import apiController from '@/utils/apiController';
import MerusDataTable from '../Tables/MerusDataTable.vue';
import CadastroToolbar from '../Toolbars/CadastroToolbar.vue';
import DateUtils from '@/utils/dateutils';
import EventBus from '@/utils/eventBus';
import { TIPO_EVENTO, isTipoEventoBaseline } from '@/utils/historicoAlteracoesRotas';
import {
    FLUXO_ORIGINAL,
    FLUXO_SELECIONADA,
    buildDirectionMarkers,
    buildRouteLayerOptions,
    estiloFluxoOriginal,
    estiloFluxoSelecionada,
    estiloFundoRota,
    iconDirecaoRota,
} from '@/utils/mapaFluxoRota';

const CERCA_COLOR = '#F57C00';
const ORIGINAL_COLOR = '#C62828';
const SELECTED_COLOR = '#1565C0';
/** Mesma cor da rota otimizada nas abas Linhas/Unidades e na Comparação. */
const OPTIMIZED_COLOR = '#8E24AA';
export default {
    name: 'HistoricoAlteracoesRotasPainel',
    components: {
        MerusDataTable,
        CadastroToolbar,
        LMap,
        LTileLayer,
        LGeoJson,
        LCircle,
        LMarker,
        LTooltip,
        LPopup,
    },
    data: () => ({
        headers: [],
        user: null,
        token: null,
        formValidado: false,
        items: [],
        loading: false,
        dti: null,
        dtf: null,
        codRota: null,
        nomeDestinoFiltro: null,
        timeProps: { useSeconds: true },
        detailShow: false,
        detailLoading: false,
        detailRows: [],
        selectedGroup: null,
        showOriginalLayer: true,
        showSelectedLayer: true,
        showCercasLayer: true,
        showOtimizadaLayer: true,
        /** Rota otimizada vigente da linha (gerada pelo monitor), no sentido do evento selecionado. */
        otimizada: null,
        otimizadaChave: null,
        otimizadaIdLinha: null,
        rawCercas: [],
        mapCercasGeojson: [],
        mapCercasCirculares: [],
        mapCercaMarkers: [],
        mapKey: 0,
        map: null,
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution:
            '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        zoom: 14,
        currentCenter: [-22.88746, -43.29185],
        mapOptions: {
            zoomSnap: 0.5,
        },
        originalColor: ORIGINAL_COLOR,
        selectedColor: SELECTED_COLOR,
        optimizedColor: OPTIMIZED_COLOR,
    }),
    watch: {
        detailShow(val) {
            if (!val) {
                this.map = null;
                this.mapKey += 1;
                this.resetCercasMap();
                this.otimizada = null;
                this.otimizadaChave = null;
                this.otimizadaIdLinha = null;
            }
        },
        detailLoading(val) {
            if (!val && this.detailShow) {
                this.$nextTick(() => this.scheduleFitMap());
            }
        },
        selectedEventRowId() {
            if (this.detailShow && !this.detailLoading) {
                this.aplicarCercasNoMapa();
                this.$nextTick(() => this.scheduleFitMap());
            }
        },
        showOriginalLayer() {
            if (this.detailShow && !this.detailLoading) {
                this.$nextTick(() => this.scheduleFitMap());
            }
        },
        showSelectedLayer() {
            if (this.detailShow && !this.detailLoading) {
                this.$nextTick(() => this.scheduleFitMap());
            }
        },
        showCercasLayer() {
            if (this.detailShow && !this.detailLoading) {
                this.$nextTick(() => this.scheduleFitMap());
            }
        },
        showOtimizadaLayer() {
            if (this.detailShow && !this.detailLoading) {
                this.$nextTick(() => this.scheduleFitMap());
            }
        },
        detailSentido() {
            if (this.detailShow && !this.detailLoading && this.otimizadaIdLinha) {
                this.carregarOtimizada(this.otimizadaIdLinha);
            }
        },
    },
    computed: {
        defaultCenter() {
            const fallback = [-22.88746, -43.29185];
            const c = this.$store && this.$store.getters
                ? this.$store.getters['config/centerDefault']
                : null;
            if (!c || !Array.isArray(c) || c.length < 2) return fallback;
            return [Number(c[0]), Number(c[1])];
        },
        originalUnderlayOptions() {
            return buildRouteLayerOptions(estiloFundoRota(ORIGINAL_COLOR, 4));
        },
        selectedUnderlayOptions() {
            return buildRouteLayerOptions(estiloFundoRota(SELECTED_COLOR, 5));
        },
        originalFlowOptions() {
            return buildRouteLayerOptions(estiloFluxoOriginal(ORIGINAL_COLOR), FLUXO_ORIGINAL);
        },
        selectedFlowOptions() {
            return buildRouteLayerOptions(estiloFluxoSelecionada(SELECTED_COLOR), FLUXO_SELECIONADA);
        },
        optimizedUnderlayOptions() {
            return buildRouteLayerOptions(estiloFundoRota(OPTIMIZED_COLOR, 5));
        },
        optimizedFlowOptions() {
            return buildRouteLayerOptions(estiloFluxoSelecionada(OPTIMIZED_COLOR), FLUXO_SELECIONADA);
        },
        otimizadaGeojson() {
            return this.parseGeojson(this.otimizada && this.otimizada.geojson);
        },
        mapOtimizadaGeojson() {
            return this.showOtimizadaLayer ? this.otimizadaGeojson : null;
        },
        mapOtimizadaDirectionMarkers() {
            if (!this.mapOtimizadaGeojson) return [];
            return buildDirectionMarkers(this.mapOtimizadaGeojson);
        },
        originalGeojson() {
            return this.parseGeojson(this.originalRow && this.originalRow.geojson);
        },
        selectedGeojson() {
            return this.parseGeojson(this.selectedEventRow && this.selectedEventRow.geojson);
        },
        selectedIsOriginal() {
            return !!(this.selectedEventRow && isTipoEventoBaseline(this.selectedEventRow.tipo_evento));
        },
        baselineTitulo() {
            const tipo = this.originalRow && this.originalRow.tipo_evento;
            if (tipo === TIPO_EVENTO.CALCULADA) return this.$t('routeChangeHistory.event.calculada');
            if (tipo === TIPO_EVENTO.TRACADO_ANTERIOR) return this.$t('routeChangeHistory.event.tracadoAnterior');
            return this.$t('routeChangeHistory.originalMerus');
        },
        mapOriginalGeojson() {
            if (!this.showOriginalLayer || this.selectedIsOriginal) return null;
            return this.originalGeojson;
        },
        mapSelectedGeojson() {
            if (!this.showSelectedLayer) return null;
            return this.selectedGeojson;
        },
        mapOriginalDirectionMarkers() {
            if (!this.mapOriginalGeojson) return [];
            return buildDirectionMarkers(this.mapOriginalGeojson);
        },
        mapSelectedDirectionMarkers() {
            if (!this.mapSelectedGeojson) return [];
            return buildDirectionMarkers(this.mapSelectedGeojson);
        },
        hasCercasMapGeometry() {
            return this.mapCercasGeojson.length > 0
                || this.mapCercasCirculares.length > 0
                || this.mapCercaMarkers.length > 0;
        },
        hasAnyMapGeometry() {
            return !!(
                this.originalGeojson
                || this.selectedGeojson
                || this.otimizadaGeojson
                || this.hasCercasMapGeometry
            );
        },
        detailSentido() {
            const row = this.selectedEventRow || this.originalRow;
            if (!row) return null;
            const params = row.parametros_custo_json;
            if (params && params.id_sentido != null) {
                const s = Number(params.id_sentido);
                return Number.isFinite(s) ? s : null;
            }
            const cod = row.cod_rota != null ? String(row.cod_rota).toUpperCase() : '';
            if (cod === 'VOLTA' || cod.endsWith('|VOLTA') || cod.endsWith('_VOLTA')) return 2;
            if (cod === 'IDA' || cod.endsWith('|IDA') || cod.endsWith('_IDA')) return 1;
            return null;
        },
        selectedEventRowId() {
            const row = this.selectedEventRow;
            return row && row.id_historico_alteracao_rota != null
                ? Number(row.id_historico_alteracao_rota)
                : null;
        },
        defaultSort() {
            return [
                { value: 'dt_ultimo_evento', options: { text: this.$t('routs.decreasing'), value: -1 } },
            ];
        },
        defaultHeaders() {
            const col = (key, value, align) => ({
                text: this.$t(`routeChangeHistory.headers.${key}`),
                value,
                align: align || null,
                sortable: true,
                filtrable: true,
                show: true,
            });
            return [
                col('destination', 'nome_destino'),
                col('routeCode', 'cod_rota'),
                col('routeName', 'nome_rota'),
                col('routingMode', 'modo_roteirizacao_extenso'),
                col('costConstancy', 'constancia_custo_extenso'),
                col('kmOriginal', 'km_original', 'end'),
                col('kmAtual', 'km_atual', 'end'),
                col('deltaKm', 'delta_km', 'end'),
                col('custoOriginal', 'custo_original', 'end'),
                col('custoAtual', 'custo_atual', 'end'),
                col('deltaCusto', 'delta_custo', 'end'),
                col('pctCusto', 'pct_custo', 'end'),
                col('lastOrigin', 'ultima_origem'),
                col('lastEvent', 'dt_ultimo_evento_extenso'),
                {
                    text: this.$t('routeChangeHistory.headers.actions'),
                    value: 'actions',
                    sortable: false,
                    filtrable: false,
                    show: true,
                },
            ];
        },
        tableHeaders() {
            return this.headers.length > 0 ? this.headers : this.defaultHeaders;
        },
        textFieldProps() {
            return {
                prependInnerIcon: 'mdi-calendar',
            };
        },
        today() {
            return new Date().toISOString().substring(0, 10);
        },
        dtiProps() {
            return {
                max: this.today,
            };
        },
        dtfProps() {
            let min = null;
            if (this.dti) {
                if (typeof this.dti === 'string') {
                    min = `${this.dti.substring(6, 10)}-${this.dti.substring(3, 5)}-${this.dti.substring(0, 2)}`;
                } else {
                    min = this.dti.toISOString().substring(0, 10);
                }
            }
            return { min };
        },
        itemsFiltered() {
            let list = this.items || [];
            const dest = this.nomeDestinoFiltro != null ? String(this.nomeDestinoFiltro).trim().toLowerCase() : '';
            if (dest) {
                list = list.filter((i) => String(i.nome_destino || '').toLowerCase().includes(dest));
            }
            return list;
        },
        originalRow() {
            const rows = this.detailRows || [];
            const isBaseline = (r) => isTipoEventoBaseline(r.tipo_evento);
            const selected = this.selectedEventRow;
            if (selected && selected.id_grupo) {
                const fromGroup = rows.find(
                    (r) => isBaseline(r)
                        && String(r.id_grupo) === String(selected.id_grupo),
                );
                if (fromGroup) return fromGroup;
            }
            const selectedMeta = this.selectedGroup;
            if (selectedMeta && selectedMeta.id_grupo) {
                const fromMeta = rows.find(
                    (r) => isBaseline(r)
                        && String(r.id_grupo) === String(selectedMeta.id_grupo),
                );
                if (fromMeta) return fromMeta;
            }
            return rows.find((r) => isBaseline(r)) || null;
        },
        selectedEventRow() {
            const rows = this.detailRows || [];
            if (!rows.length) return null;
            const isBaseline = (r) => isTipoEventoBaseline(r.tipo_evento);
            const selected = this.selectedGroup;
            if (selected && selected.id_historico_alteracao_rota != null) {
                const match = rows.find(
                    (r) => Number(r.id_historico_alteracao_rota)
                        === Number(selected.id_historico_alteracao_rota),
                );
                if (match) return match;
            }
            if (selected && selected.id_versao != null) {
                const matchV = rows.find(
                    (r) => Number(r.id_versao) === Number(selected.id_versao)
                        && !isBaseline(r)
                        && (
                            !selected.id_grupo
                            || String(r.id_grupo) === String(selected.id_grupo)
                        ),
                );
                if (matchV) return matchV;
            }
            // Preferência: último evento não-baseline da rota (última alteração).
            for (let i = rows.length - 1; i >= 0; i -= 1) {
                if (!isBaseline(rows[i])) return rows[i];
            }
            return rows[rows.length - 1];
        },
        detailTitle() {
            const g = this.selectedGroup;
            const nome = g ? [g.cod_rota, g.nome_rota || g.nome_destino].filter(Boolean).join(' - ') : '';
            return nome ? `${this.$t('routeChangeHistory.detailTitle')} — ${nome}` : this.$t('routeChangeHistory.detailTitle');
        },
        selecionadaTitulo() {
            return this.selectedEventRow && this.selectedEventRow.tipo_evento === 'INFORMADA'
                ? this.$t('routeChangeHistory.event.informada')
                : this.$t('routeChangeHistory.currentEdited');
        },
        /** Mesmo formato dos cards do diálogo das abas Linhas/Unidades: valor e a diferença para a base. */
        resumoSelecionada() {
            const row = this.selectedEventRow;
            if (!row) return [];
            const c = this.compare;
            const lista = [
                {
                    label: this.$t('routeChangeHistory.headers.kmAtual'),
                    valor: this.formatKm(c.km_atual),
                    deltaNum: c.delta_km,
                    delta: c.delta_km ? this.formatKmDelta(c.delta_km) : null,
                },
                {
                    label: this.$t('routeChangeHistory.headers.custoAtual'),
                    valor: this.formatMoney(c.custo_atual),
                    deltaNum: c.delta_custo,
                    delta: c.delta_custo ? this.formatMoneyDelta(c.delta_custo) : null,
                },
            ];
            if (row.id_modo_roteirizacao != null) {
                lista.push({
                    label: this.$t('routeChangeHistory.headers.routingMode'),
                    valor: this.modoRoteirizacaoLabel(row.id_modo_roteirizacao),
                });
            }
            lista.push(
                { label: this.$t('routeChangeHistory.eventDate'), valor: this.formatDateTime(row.dt_evento) },
                {
                    label: this.$t('routeChangeHistory.eventOrigin'),
                    valor: `${this.tipoEventoLabel(row.tipo_evento)} · ${this.origemLabel(row.origem)}`,
                },
            );
            return lista;
        },
        resumoBaseline() {
            const row = this.originalRow;
            if (!row) return [];
            const c = this.compare;
            const lista = [
                { label: this.$t('routeChangeHistory.headers.kmOriginal'), valor: this.formatKm(c.km_original) },
                { label: this.$t('routeChangeHistory.headers.custoOriginal'), valor: this.formatMoney(c.custo_original) },
                { label: this.$t('routeChangeHistory.headers.routeCode'), valor: row.cod_rota || '—' },
            ];
            if (row.id_modo_roteirizacao != null) {
                lista.push({
                    label: this.$t('routeChangeHistory.headers.routingMode'),
                    valor: this.modoRoteirizacaoLabel(row.id_modo_roteirizacao),
                });
            }
            lista.push({
                label: this.$t('routeChangeHistory.headers.costConstancy'),
                valor: this.constanciaCustoLabel(
                    (this.selectedEventRow && this.selectedEventRow.constancia_custo) || row.constancia_custo,
                ),
            });
            return lista;
        },
        compare() {
            const o = this.originalRow;
            const c = this.selectedEventRow;
            const kmO = o && o.km != null ? Number(o.km) : null;
            const kmC = c && c.km != null ? Number(c.km) : kmO;
            const custoO = o && o.custo_total != null ? Number(o.custo_total) : null;
            const custoC = c && c.custo_total != null ? Number(c.custo_total) : custoO;
            return {
                km_original: kmO,
                km_atual: kmC,
                custo_original: custoO,
                custo_atual: custoC,
                delta_km: kmO != null && kmC != null ? kmC - kmO : null,
                delta_custo: custoO != null && custoC != null ? custoC - custoO : null,
            };
        },
    },
    mounted() {
        this.token = sessionStorage.getItem('api');
        try {
            this.user = JSON.parse(sessionStorage.getItem('user'));
        } catch (e) {
            this.user = null;
        }
        this.currentCenter = this.defaultCenter.slice();
        // 30 dias operacionais (hora inicial do dia de operação das Configurações)
        [this.dti, this.dtf] = DateUtils.periodoDiasOperacionais(
            this.$store.getters['config/horaInicialDiaOperacao'],
            30,
        );
        this.populaRelatorio();
    },
    methods: {
        parseGeojson(gj) {
            if (!gj) return null;
            if (typeof gj === 'string') {
                try {
                    return JSON.parse(gj);
                } catch (e) {
                    return null;
                }
            }
            if (typeof gj === 'object') return gj;
            return null;
        },
        closeDetail() {
            this.detailShow = false;
        },
        selectTimelineRow(row) {
            if (!row) return;
            this.selectedGroup = {
                ...(this.selectedGroup || {}),
                id_historico_alteracao_rota: row.id_historico_alteracao_rota,
                id_versao: row.id_versao,
                id_grupo: row.id_grupo || (this.selectedGroup && this.selectedGroup.id_grupo),
            };
        },
        isTimelineSelected(row) {
            if (!row || this.selectedEventRowId == null) return false;
            return Number(row.id_historico_alteracao_rota) === this.selectedEventRowId;
        },
        onMapReady() {
            const ref = this.$refs.detailMapRef;
            if (ref) {
                this.map = ref.mapObject;
                this.$nextTick(() => {
                    if (this.map) this.map.invalidateSize();
                    this.scheduleFitMap();
                });
            }
        },
        scheduleFitMap() {
            this.$nextTick(() => this.fitMap());
            if (typeof requestAnimationFrame === 'function') {
                requestAnimationFrame(() => this.fitMap());
            }
            setTimeout(() => this.fitMap(), 280);
        },
        fitMap() {
            const map = this.map
                || (this.$refs.detailMapRef && this.$refs.detailMapRef.mapObject);
            if (!map) return;

            const layers = [this.mapOriginalGeojson, this.mapSelectedGeojson, this.mapOtimizadaGeojson].filter(Boolean);
            const hasCercas = this.showCercasLayer && this.hasCercasMapGeometry;
            if (!layers.length && !hasCercas) {
                try {
                    map.setView(this.defaultCenter.slice(), this.zoom, { animate: false });
                    map.invalidateSize({ animate: false });
                } catch (e) {
                    // ignore
                }
                return;
            }

            try {
                let bounds = null;
                layers.forEach((gj) => {
                    try {
                        const b = L.geoJSON(gj).getBounds();
                        if (!b || (typeof b.isValid === 'function' && !b.isValid())) return;
                        bounds = bounds ? bounds.extend(b) : b;
                    } catch (e) {
                        // ignore invalid geometry
                    }
                });
                if (hasCercas) {
                    this.mapCercasGeojson.forEach((cerca) => {
                        try {
                            const b = L.geoJSON(cerca.geojson).getBounds();
                            if (!b || (typeof b.isValid === 'function' && !b.isValid())) return;
                            bounds = bounds ? bounds.extend(b) : b;
                        } catch (e) {
                            // ignore
                        }
                    });
                    this.mapCercasCirculares.forEach((cerca) => {
                        const lat = Number(cerca.lat_centro);
                        const lng = Number(cerca.lng_centro);
                        const r = Number(cerca.raio_mts) || 0;
                        if (!Number.isFinite(lat) || !Number.isFinite(lng) || r <= 0) return;
                        try {
                            const circle = L.circle([lat, lng], { radius: r });
                            const b = circle.getBounds();
                            bounds = bounds ? bounds.extend(b) : b;
                        } catch (e) {
                            // ignore
                        }
                    });
                    this.mapCercaMarkers.forEach((pin) => {
                        if (!Number.isFinite(pin.lat) || !Number.isFinite(pin.lng)) return;
                        const ll = L.latLng(pin.lat, pin.lng);
                        bounds = bounds ? bounds.extend(ll) : L.latLngBounds([ll]);
                    });
                }
                map.invalidateSize({ animate: false });
                if (bounds && (typeof bounds.isValid !== 'function' || bounds.isValid())) {
                    map.fitBounds(bounds, { padding: [24, 24], maxZoom: 16 });
                } else {
                    map.setView(this.defaultCenter.slice(), this.zoom, { animate: false });
                }
            } catch (e) {
                // ignore fit errors
            }
        },
        resetCercasMap() {
            this.rawCercas = [];
            this.mapCercasGeojson = [];
            this.mapCercasCirculares = [];
            this.mapCercaMarkers = [];
            this.showCercasLayer = true;
        },
        latLng(lat, lng) {
            const fallback = L.latLng(this.defaultCenter[0], this.defaultCenter[1]);
            const la = parseFloat(lat);
            const ln = parseFloat(lng);
            if (Number.isNaN(la) || Number.isNaN(ln)) return fallback;
            return L.latLng(la, ln);
        },
        iconPinCerca(color) {
            const fill = color || CERCA_COLOR;
            return L.divIcon({
                className: 'har-map-cerca-pin',
                html:
                    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="28" height="28" aria-hidden="true">`
                    + `<path fill="${fill}" stroke="#ffffff" stroke-width="1.5" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z"/>`
                    + `</svg>`,
                iconSize: [28, 28],
                iconAnchor: [14, 28],
                popupAnchor: [0, -28],
            });
        },
        iconDirecaoRota(bearing, color) {
            return iconDirecaoRota(bearing, color || SELECTED_COLOR);
        },
        cercaPassaFiltroSentido(cerca, sentido) {
            if (sentido == null || Number(sentido) === -1) return true;
            return (
                Number(cerca.id_sentido) === Number(sentido)
                || Number(cerca.id_sentido) === -1
            );
        },
        cercaPinPosition(cerca, geojson) {
            const la = parseFloat(cerca.lat_centro);
            const ln = parseFloat(cerca.lng_centro);
            if (!Number.isNaN(la) && !Number.isNaN(ln)) {
                return [la, ln];
            }
            if (geojson) {
                return this.extractFirstLatLng(geojson);
            }
            return null;
        },
        extractFirstLatLng(geojson) {
            if (!geojson) return null;
            if (geojson.type === 'Feature') {
                return this.extractFirstLatLng(geojson.geometry);
            }
            if (geojson.type === 'FeatureCollection') {
                const feat = geojson.features && geojson.features[0];
                return feat ? this.extractFirstLatLng(feat) : null;
            }
            const coords = geojson.coordinates;
            if (!coords) return null;
            const walk = (c) => {
                if (!Array.isArray(c) || !c.length) return null;
                if (typeof c[0] === 'number' && typeof c[1] === 'number') {
                    return [c[1], c[0]];
                }
                return walk(c[0]);
            };
            if (geojson.type === 'LineString') return walk(coords);
            if (geojson.type === 'MultiLineString') return walk(coords[0]);
            if (geojson.type === 'Polygon') return walk(coords[0]);
            if (geojson.type === 'Point') return walk(coords);
            return null;
        },
        pushCercaMarker(cerca, color, nome, geojson) {
            const pos = this.cercaPinPosition(cerca, geojson);
            if (!pos) return;
            this.mapCercaMarkers.push({
                id_cerca: cerca.id_cerca,
                lat: pos[0],
                lng: pos[1],
                nome,
                color,
            });
        },
        aplicarCercasNoMapa() {
            const sentido = this.detailSentido;
            this.mapCercasGeojson = [];
            this.mapCercasCirculares = [];
            this.mapCercaMarkers = [];

            (this.rawCercas || []).forEach((cerca) => {
                if (cerca.cod_tipo_cerca === 'POI') return;
                if (!this.cercaPassaFiltroSentido(cerca, sentido)) return;

                const color = CERCA_COLOR;
                const nome = cerca.nome_cerca || cerca.cod_cerca || '';

                if (Number(cerca.is_circular) === 1) {
                    const r = Number(cerca.raio_mts);
                    if (
                        cerca.lat_centro == null
                        || cerca.lng_centro == null
                        || Number.isNaN(r)
                        || r <= 0
                    ) {
                        return;
                    }
                    this.mapCercasCirculares.push({
                        ...cerca,
                        _strokeColor: color,
                        _fillColor: color,
                    });
                    this.pushCercaMarker(cerca, color, nome);
                    return;
                }

                const gj = this.parseGeojson(cerca.geojson);
                if (!gj) return;
                this.mapCercasGeojson.push({
                    ...cerca,
                    geojson: gj,
                    style: {
                        color,
                        fillColor: color,
                        fillOpacity: 0.22,
                        weight: 2,
                    },
                    options: {
                        onEachFeature: (feat, layer) => {
                            const label = nome || (feat.properties && feat.properties.name) || '';
                            if (label) layer.bindPopup(`<strong>${String(label)}</strong>`);
                        },
                    },
                });
                this.pushCercaMarker(cerca, color, nome, gj);
            });
        },
        async carregarCercasLinha(idLinha) {
            const id = Number(idLinha);
            if (!Number.isFinite(id) || id <= 0) {
                this.rawCercas = [];
                this.aplicarCercasNoMapa();
                return;
            }
            try {
                const cercasRes = await apiController.request(
                    apiController.endpoints.getCercasporlinha,
                    { data: [id], silent: true },
                );
                this.rawCercas = Array.isArray(cercasRes.data) ? cercasRes.data : [];
                this.aplicarCercasNoMapa();
            } catch (e) {
                this.rawCercas = [];
                this.aplicarCercasNoMapa();
            }
        },
        /**
         * Rota otimizada vigente da linha no sentido do evento (sem sentido: ida). Linha circular guarda
         * a otimizada no sentido -1. Sem permissão do endpoint ou sem otimizada, a camada fica vazia.
         */
        async carregarOtimizada(idLinha) {
            const sentido = this.detailSentido != null ? this.detailSentido : 1;
            const chave = `${idLinha}_${sentido}`;
            if (this.otimizadaChave === chave) return;
            this.otimizadaChave = chave;
            const busca = async (idSentido) => {
                const res = await apiController.request(
                    apiController.endpoints.getHistoricorotasotimizadaslinha,
                    { data: { acao: 'versao', id_linha: idLinha, id_sentido: idSentido }, silent: true },
                );
                return res && res.data && res.data.geojson ? res.data : null;
            };
            let versao = null;
            try {
                versao = (await busca(sentido)) || (sentido !== -1 ? await busca(-1) : null);
            } catch (e) {
                versao = null;
            }
            if (this.otimizadaChave !== chave) return;
            this.otimizada = versao;
            if (this.detailShow && !this.detailLoading) this.$nextTick(() => this.scheduleFitMap());
        },
        async carregarCercaDestino(idCerca) {
            const id = Number(idCerca);
            if (!Number.isFinite(id) || id <= 0) {
                this.rawCercas = [];
                this.aplicarCercasNoMapa();
                return;
            }
            try {
                const res = await apiController.request(
                    apiController.endpoints.getCercaporid,
                    { params: { id }, silent: true },
                );
                const data = res && res.data;
                const cerca = Array.isArray(data)
                    ? data[0]
                    : (data && data.id_cerca != null ? data : null);
                this.rawCercas = cerca && cerca.id_cerca != null ? [cerca] : [];
                this.aplicarCercasNoMapa();
            } catch (e) {
                this.rawCercas = [];
                this.aplicarCercasNoMapa();
            }
        },
        formatKm(v) {
            if (v == null || v === '') return '—';
            const n = Number(v);
            if (!Number.isFinite(n)) return '—';
            return `${n.toFixed(2)} km`;
        },
        formatKmDelta(v) {
            if (v == null || v === '') return '—';
            const n = Number(v);
            if (!Number.isFinite(n)) return '—';
            const sign = n > 0 ? '+' : '';
            return `${sign}${n.toFixed(2)} km`;
        },
        formatMoney(v) {
            if (v == null || v === '') return '—';
            const n = Number(v);
            if (!Number.isFinite(n)) return '—';
            const isEs = this.$i18n && String(this.$i18n.locale).trim() === 'es-MX';
            return n.toLocaleString(isEs ? 'es-MX' : 'pt-BR', {
                style: 'currency',
                currency: isEs ? 'MXN' : 'BRL',
            });
        },
        formatMoneyDelta(v) {
            if (v == null || v === '') return '—';
            const n = Number(v);
            if (!Number.isFinite(n)) return '—';
            const formatted = this.formatMoney(Math.abs(n));
            if (n > 0) return `+${formatted}`;
            if (n < 0) return `-${formatted}`;
            return formatted;
        },
        formatPct(v) {
            const n = Number(v);
            if (!Number.isFinite(n)) return '—';
            const sign = n > 0 ? '+' : '';
            return `${sign}${n.toFixed(2)}%`;
        },
        deltaClass(v) {
            const n = Number(v);
            if (!Number.isFinite(n) || n === 0) return '';
            return n > 0 ? 'error--text' : 'success--text';
        },
        origemLabel(origem) {
            if (origem === 'ROTEIRIZACAO') return this.$t('routeChangeHistory.origin.roteirizacao');
            if (origem === 'CRUD_LINHAS') return this.$t('routeChangeHistory.origin.crudLinhas');
            if (origem === 'API_LINHAS') return this.$t('routeChangeHistory.origin.apiLinhas');
            return origem || '—';
        },
        modoRoteirizacaoLabel(idModo, fallback) {
            const n = Number(idModo);
            if (n === 1) return this.$t('routePlanning.fields.routingModeOperational');
            if (n === 2) return this.$t('routePlanning.fields.routingModeSimulation');
            if (n === 3) return this.$t('routePlanning.fields.routingModePreview');
            return fallback || '—';
        },
        constanciaCustoLabel(codigo, fallback) {
            const raw = codigo != null ? String(codigo).trim().toUpperCase() : '';
            if (raw === 'DIARIO' || raw === 'DIÁRIO') {
                return this.$t('routeChangeHistory.costConstancy.daily');
            }
            if (raw === 'MENSAL') {
                return this.$t('routeChangeHistory.costConstancy.monthly');
            }
            if (raw === 'CICLO_CONTRATO' || raw === 'CICLO') {
                return this.$t('routeChangeHistory.costConstancy.contractCycle');
            }
            if (raw === 'VIAGEM' || !raw) {
                return this.$t('routeChangeHistory.costConstancy.trip');
            }
            return fallback || this.$t('routeChangeHistory.costConstancy.trip');
        },
        tipoEventoLabel(tipo) {
            if (tipo === 'ORIGINAL') return this.$t('routeChangeHistory.event.original');
            if (tipo === 'PUBLICADA') return this.$t('routeChangeHistory.event.publicada');
            if (tipo === 'EDITADA_CRUD') return this.$t('routeChangeHistory.event.editadaCrud');
            if (tipo === 'CALCULADA') return this.$t('routeChangeHistory.event.calculada');
            if (tipo === 'INFORMADA') return this.$t('routeChangeHistory.event.informada');
            if (tipo === TIPO_EVENTO.TRACADO_ANTERIOR) return this.$t('routeChangeHistory.event.tracadoAnterior');
            return tipo || '—';
        },
        timelineColor(tipo) {
            if (isTipoEventoBaseline(tipo)) return 'primary';
            if (tipo === 'PUBLICADA') return 'info';
            if (tipo === 'EDITADA_CRUD') return 'warning';
            if (tipo === 'INFORMADA') return 'secondary';
            return 'grey';
        },
        formatDateTime(dt) {
            if (!dt) return '—';
            try {
                const d = new Date(dt);
                if (Number.isNaN(d.getTime())) return String(dt);
                const pad = (n) => String(n).padStart(2, '0');
                return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} `
                    + `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
            } catch (e) {
                return String(dt);
            }
        },
        /** Data e hora: o período segue o dia operacional, não o dia de calendário. */
        toSqlDateTime(value) {
            if (!value) return null;
            const d = value instanceof Date ? value : new Date(value);
            if (Number.isNaN(d.getTime())) return null;
            const pad = (n) => String(n).padStart(2, '0');
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} `
                + `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
        },
        async populaRelatorio() {
            this.loading = true;
            try {
                const query = {};
                const dti = this.toSqlDateTime(this.dti);
                const dtf = this.toSqlDateTime(this.dtf);
                if (dti) query.dti = dti;
                if (dtf) query.dtf = dtf;
                if (this.codRota) query.cod_rota = String(this.codRota).trim();

                const res = await apiController.request(
                    apiController.endpoints.getHistoricoalteracoesrotas,
                    { query, silent: true },
                );
                this.items = Array.isArray(res.data) ? res.data : [];
            } catch (e) {
                this.items = [];
                EventBus.$emit('show-error', { error: e });
            } finally {
                this.loading = false;
            }
        },
        async openDetail(item) {
            if (!item) return;
            const hasLinha = item.id_linha != null && Number(item.id_linha) > 0;
            const hasRota = item.id_rota != null || (item.cod_rota && String(item.cod_rota).trim());
            if (!item.id_grupo && !hasRota && !hasLinha) return;

            this.selectedGroup = item;
            this.showOriginalLayer = true;
            this.showSelectedLayer = true;
            this.showCercasLayer = true;
            this.resetCercasMap();
            this.mapKey += 1;
            this.map = null;
            this.detailShow = true;
            this.detailLoading = true;
            this.detailRows = [];
            try {
                const query = {};
                const origem = String(item.ultima_origem || item.origem || '').toUpperCase();
                const tipo = String(item.ultimo_tipo_evento || item.tipo_evento || '').toUpperCase();
                const codRota = item.cod_rota != null ? String(item.cod_rota).trim() : '';
                const isLinhaKmHist =
                    hasLinha
                    && (
                        origem === 'CRUD_LINHAS'
                        || origem === 'API_LINHAS'
                        || tipo === 'INFORMADA'
                        || tipo === 'CALCULADA'
                        || codRota === 'IDA'
                        || codRota === 'VOLTA'
                        || codRota.indexOf('|') !== -1
                    );

                if (isLinhaKmHist) {
                    // Escopo por linha: não misturar outras linhas via id_rota compartilhado
                    // ou cod_rota legado "IDA"/"VOLTA". Timeline = todos os eventos da linha
                    // (e do cod_rota único, se houver).
                    query.id_linha = Number(item.id_linha);
                    if (codRota && codRota !== 'IDA' && codRota !== 'VOLTA') {
                        query.cod_rota = codRota;
                    }
                    // id_grupo reforça o match quando a listagem já trouxe o grupo.
                    if (item.id_grupo) {
                        query.id_grupo = item.id_grupo;
                    }
                } else {
                    if (item.id_rota != null && Number(item.id_rota) > 0) {
                        query.id_rota = Number(item.id_rota);
                    }
                    if (codRota) {
                        query.cod_rota = codRota;
                    }
                    if (item.id_grupo) {
                        query.id_grupo = item.id_grupo;
                    }
                }
                if (item.id_empresa != null && Number(item.id_empresa) > 0) {
                    query.id_empresa = Number(item.id_empresa);
                }

                const res = await apiController.request(
                    apiController.endpoints.getHistoricoalteracoesrotasporgrupo,
                    { query, silent: true },
                );
                this.detailRows = Array.isArray(res.data) ? res.data : [];

                const idLinhaFromRows = (this.detailRows || [])
                    .map((r) => (r.id_linha != null ? Number(r.id_linha) : null))
                    .find((id) => Number.isFinite(id) && id > 0);
                const idLinha = hasLinha ? Number(item.id_linha) : idLinhaFromRows;
                if (idLinha) {
                    this.otimizadaIdLinha = idLinha;
                    await Promise.all([this.carregarCercasLinha(idLinha), this.carregarOtimizada(idLinha)]);
                } else {
                    const idCerca = (this.detailRows || [])
                        .map((r) => (r.id_cerca_destino != null ? Number(r.id_cerca_destino) : null))
                        .find((id) => Number.isFinite(id) && id > 0)
                        || (item.id_cerca_destino != null ? Number(item.id_cerca_destino) : null);
                    if (idCerca) {
                        await this.carregarCercaDestino(idCerca);
                    }
                }
            } catch (e) {
                this.detailRows = [];
            } finally {
                this.detailLoading = false;
            }
        },
    },
};
</script>

<style scoped>
.har-map {
    height: 460px;
}

.har-swatch {
    display: inline-block;
    width: 18px;
    height: 4px;
    border-radius: 2px;
    margin-right: 6px;
    vertical-align: middle;
}

.har-swatch--dashed {
    height: 0;
    border-top: 3px dashed;
    border-radius: 0;
}

.har-swatch--fence {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #F57C00;
}

.har-timeline {
    max-height: 560px;
    overflow-y: auto;
}

.har-timeline-item {
    cursor: pointer;
    border-radius: 6px;
    padding: 6px 8px;
    margin: -6px -8px;
    transition: background-color 0.15s ease;
}

.har-timeline-item:hover {
    background-color: rgba(21, 101, 192, 0.06);
}

.har-timeline-item--active {
    background-color: rgba(21, 101, 192, 0.12);
    box-shadow: inset 3px 0 0 #1565C0;
}
</style>

<style>
.har-map-cerca-pin {
    background: transparent !important;
    border: none !important;
}
</style>

